import { Kanban } from 'lucide-react'
import DefaultTabs from '../../../../components/common/Tabs'
import { useProduct } from '../../../../context/ProductContext'
import Business from './Pipelines'

export function ProductTabs() {
    const { detail } = useProduct()
    if (!detail) return null

    const tabsData = [
        {
            icon: <Kanban className='h-4 w-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Negócios</p>
                    {detail.business.length > 0 && (
                        <p className='text-xs font-bold text-brand-400'>{detail.business.length}</p>
                    )}
                </div>
            ),
            value: 'business',
            content: <Business />
        }
    ]

    return <DefaultTabs tabs={tabsData} defaultValue='business' />
}
